import clientConfig from '../config/client';

export default {
  familyType: {
    SINGLE: "Single",
    COUPLE: "Couple",
    SINGLE_DEPENDANT: "SingleDependant",
    COUPLE_DEPENDANT: "CoupleDependant",
  },
  homeType: {
    MORTGAGE: "Mortgage",
    RENT: "Rent",
    NONE: "None",
  },
  memberType: {
    EMPLOYER: "Accumulation 1, Accumulation 2, or DBD",
    PERSONAL: "Personal Account",
    MERGED: `Accumulation 1 ${clientConfig.defaults.stepData.mergedMemberInsurance}`,
    SPECIAL: "Special"
  },
  occupation: {
    PROFESSIONAL: "Professional / Office work",
    WHITE: "White colar",
    LIGHT: "Light manual",
    MANUAL: "Manual",
    HEAVY: "Heavy manual",
    SPECIAL: "Special risk",
  }
};